// src/onboarding/OnbTileArt.jsx
// Phase 37 — extracted from src/App.jsx (Plan 37-03).

export default function OnbTileArt({ variant }) {
  const w = 132, h = 64;
  const common = {
    width: "100%", height: "100%",
    viewBox: `0 0 ${w} ${h}`,
    preserveAspectRatio: "xMidYMid slice",
    "aria-hidden": true,
  };
  switch (variant) {
    case "front-garden":
      return (
        <div className="onb-tile-art" style={{ "--art-bg": "#e7eedf" }}>
          <svg {...common}>
            <rect x="0" y="44" width="132" height="20" fill="#c9b896" opacity="0.6"/>
            <rect x="52" y="40" width="28" height="6" fill="#b8a47e" opacity="0.7"/>
            <rect x="56" y="34" width="20" height="10" fill="#c9b896" opacity="0.75"/>
            <circle cx="20" cy="40" r="8" fill="#6b8a55"/>
            <circle cx="32" cy="38" r="10" fill="#5a7a4a"/>
            <circle cx="108" cy="40" r="9" fill="#6b8a55"/>
            <circle cx="96" cy="38" r="8" fill="#5a7a4a"/>
            <rect x="40" y="10" width="52" height="22" fill="#e8dcc4" opacity="0.8"/>
            <path d="M 38 10 L 66 0 L 94 10" fill="#c99f72" opacity="0.8"/>
          </svg>
        </div>
      );
    case "back-garden":
      return (
        <div className="onb-tile-art" style={{ "--art-bg": "#dce8d1" }}>
          <svg {...common}>
            <rect x="0" y="28" width="132" height="36" fill="#9cb873" opacity="0.55"/>
            <rect x="0" y="44" width="132" height="20" fill="#78965b" opacity="0.45"/>
            <ellipse cx="24" cy="36" rx="20" ry="16" fill="#5a7a4a"/>
            <rect x="22" y="40" width="4" height="12" fill="#6b4a2b"/>
            <circle cx="74" cy="50" r="3" fill="#d98b5f"/>
            <circle cx="82" cy="48" r="3" fill="#a78bca"/>
            <circle cx="90" cy="52" r="3" fill="#e8a547"/>
            <circle cx="100" cy="48" r="3" fill="#c96878"/>
            <circle cx="110" cy="52" r="3" fill="#d98b5f"/>
          </svg>
        </div>
      );
    case "balcony":
      return (
        <div className="onb-tile-art" style={{ "--art-bg": "#e4dccf" }}>
          <svg {...common}>
            <rect x="0" y="54" width="132" height="10" fill="#8b6f47" opacity="0.5"/>
            <line x1="16" y1="30" x2="16" y2="54" stroke="#8b6f47" strokeWidth="2" opacity="0.6"/>
            <line x1="48" y1="30" x2="48" y2="54" stroke="#8b6f47" strokeWidth="2" opacity="0.6"/>
            <line x1="84" y1="30" x2="84" y2="54" stroke="#8b6f47" strokeWidth="2" opacity="0.6"/>
            <line x1="116" y1="30" x2="116" y2="54" stroke="#8b6f47" strokeWidth="2" opacity="0.6"/>
            <line x1="10" y1="30" x2="122" y2="30" stroke="#8b6f47" strokeWidth="2" opacity="0.7"/>
            <rect x="22" y="34" width="20" height="16" rx="2" fill="#b8845a"/>
            <ellipse cx="32" cy="32" rx="12" ry="6" fill="#7a9865"/>
            <rect x="60" y="36" width="18" height="14" rx="2" fill="#d98b5f"/>
            <ellipse cx="69" cy="34" rx="10" ry="5" fill="#a78bca"/>
            <rect x="92" y="34" width="20" height="16" rx="2" fill="#b8845a"/>
            <ellipse cx="102" cy="32" rx="12" ry="6" fill="#6b8a55"/>
          </svg>
        </div>
      );
    case "greenhouse":
      return (
        <div className="onb-tile-art" style={{ "--art-bg": "#e0ebe4" }}>
          <svg {...common}>
            <path d="M 30 54 L 30 26 L 66 10 L 102 26 L 102 54 Z"
                  fill="rgba(200,220,210,0.6)" stroke="#8b6f47" strokeWidth="1.2"/>
            <line x1="66" y1="10" x2="66" y2="54" stroke="#8b6f47" strokeWidth="0.8" opacity="0.6"/>
            <line x1="30" y1="32" x2="102" y2="32" stroke="#8b6f47" strokeWidth="0.6" opacity="0.5"/>
            <circle cx="48" cy="42" r="6" fill="#5a7a4a"/>
            <circle cx="82" cy="42" r="6" fill="#6b8a55"/>
            <rect x="0" y="54" width="132" height="10" fill="#8b6f47" opacity="0.3"/>
          </svg>
        </div>
      );
    case "allotment":
      return (
        <div className="onb-tile-art" style={{ "--art-bg": "#e8dfcc" }}>
          <svg {...common}>
            <rect x="0" y="30" width="132" height="34" fill="#b8845a" opacity="0.35"/>
            {[34, 40, 46, 52, 58].map((y, i) => (
              <line key={i} x1="4" y1={y} x2="128" y2={y} stroke="#6b4a2b" strokeWidth="1" opacity="0.6"/>
            ))}
            {[0, 1, 2, 3, 4, 5, 6, 7, 8].map(i => (
              <circle key={i} cx={14 + i * 14} cy={34} r="1.5" fill="#5a7a4a"/>
            ))}
            <rect x="94" y="12" width="26" height="20" fill="#8b6f47" opacity="0.8"/>
            <path d="M 92 12 L 107 4 L 122 12" fill="#6b4a2b" opacity="0.9"/>
          </svg>
        </div>
      );
    default:
      return <div className="onb-tile-art"/>;
  }
}
